export function generatePluginSchema(
  id: string,
  label: string,
  pluginName: string,
  pluginUrl: string,
  other = {}
) {
  return {
    id,
    label,
    json: {
      type: pluginName,
      pluginName,
      pluginUrl,
      size: "col-md-12",
      style: {},
      properties: {},
      data: {},
      fields: [],
      ...other,
    },
  };
}
